import axios from "axios";
import { BaseUrl } from "./api";
import {
    START_FETCH_HOLIDAY_CODE_LIST,
    HOLIDAY_CODE_LIST_FETCH_SUCCESS,
    HOLIDAY_CODE_LIST_FETCH_FAILED,
} from "./types";

export const fetchHolidayCode = (token) => {
    return async (dispatch) => {
        dispatch({
            type: START_FETCH_HOLIDAY_CODE_LIST,
        });
        try {
            const res = await axios.get(`${BaseUrl}/holiday_codes`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    dataType: "json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (res.statusText === "OK") {
                dispatch({
                    type: HOLIDAY_CODE_LIST_FETCH_SUCCESS,
                    payload: res.data,
                });
            } else {
                dispatch({
                    type: HOLIDAY_CODE_LIST_FETCH_FAILED,
                    payload: "Fetching holiday code list failed",
                });
            }
        } catch (error) {
            dispatch({
                type: HOLIDAY_CODE_LIST_FETCH_FAILED,
                payload: error.message,
            });
        }
    };
};
